import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";

interface ChoiceCardProps {
  letter: "A" | "B" | "C" | "D";
  text: string;
  selected: boolean;
  onSelect: () => void;
}

export function ChoiceCard({ letter, text, selected, onSelect }: ChoiceCardProps) {
  return (
    <motion.button
      type="button"
      onClick={onSelect}
      whileHover={!selected ? { y: -2 } : {}}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={`flex w-full items-center gap-3 rounded-xl px-3.5 py-2.5 text-left transition-colors duration-200 ${
        selected
          ? "border-2 border-fuchsia-400/60 bg-gradient-to-r from-fuchsia-500/15 via-violet-500/15 to-cyan-500/15 shadow-[0_0_24px_-4px_rgba(236,72,153,0.5)]"
          : "border border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10"
      }`}
    >
      <div
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-fuchsia-500 to-violet-500 font-mono text-xs font-bold text-white ${
          selected ? "shadow-md shadow-fuchsia-500/50" : ""
        }`}
      >
        {letter}
      </div>
      <span className="flex-1 text-[13px] leading-[1.45] text-white/90">{text}</span>
      <div className="flex h-4 w-4 shrink-0 items-center justify-center">
        <AnimatePresence>
          {selected && (
            <motion.span
              initial={{ x: 8, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 8, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="text-fuchsia-300"
            >
              <Check className="h-4 w-4" />
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </motion.button>
  );
}